// src/components/Button.js
import { GRADIENTS, C, RADIUS } from '../styles/theme';

export function Button({ children, onClick, variant = 'primary', size = 'md', full = false, disabled = false, style = {} }) {
  const s = {
    border: 'none', cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.5 : 1,
    width: full ? '100%' : 'auto',
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8,
    transition: 'transform 0.15s',
    borderRadius: RADIUS.pill,
    ...SIZES[size], ...VARIANTS[variant], ...style,
  };
  return (
    <button style={s} onClick={onClick} disabled={disabled}
      onMouseDown={e => { if (!disabled) e.currentTarget.style.transform = 'scale(0.97)'; }}
      onMouseUp={e => { e.currentTarget.style.transform = 'scale(1)'; }}
      onTouchStart={e => { if (!disabled) e.currentTarget.style.transform = 'scale(0.97)'; }}
      onTouchEnd={e => { e.currentTarget.style.transform = 'scale(1)'; }}
    >{children}</button>
  );
}

const SIZES = {
  sm: { padding: '10px 18px', fontSize: 13 },
  md: { padding: '14px 24px', fontSize: 15 },
  lg: { padding: '18px 28px', fontSize: 18 },
};
const VARIANTS = {
  primary:   { background: GRADIENTS.primary,   color: '#fff', fontWeight: '600' },
  secondary: { background: GRADIENTS.secondary, color: '#fff', fontWeight: '600' },
  ghost:     { background: 'none', border: `1px solid ${C.sand}`, color: C.textMid, fontWeight: '500' },
  muted:     { background: C.bgMuted, color: C.textMid, fontWeight: '500' },
};
